import React, { useState, useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import update from 'react-addons-update'
import Modal from 'react-modal'
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'
import GridList from '../GridList'
import AppDispatcher from '../../../dispatchers/AppDispatcher'

import {
  CapitalButton,
} from '../Navigation/Buttons'

import {
  SelectInput,
} from '../Inputs/Inputs'

import WarningTriangle from '../Graphics/WarningTriangle'
import SelectionCheckIcon from '../Graphics/SelectionCheckIcon'
import {
  setDevices as setDevicesAction,
} from '../../../actions/actions'
import AppStore from '../../../stores/AppStore'

import styles from '../../../../css/home.module.css'
import notificationStyles from '../../../../css/notifications.module.css'

Modal.setAppElement('#app')

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(196, 196, 196, 0.8)',
    zIndex: 100,
  },
  content: {
    top: '50%',
    left: '50%',
    maxWidth: '400px',
    minWidth: '300px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '10px',
    boxShadow: 'none',
    border: '3px solid #d00000',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    color: '#d00000',
    textAlign: 'center',
  },
}

const completionStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(196, 196, 196, 0.8)',
    zIndex: 100,
  },
  content: {
    top: '50%',
    left: '50%',
    maxWidth: '400px',
    minWidth: '300px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '10px',
    boxShadow: 'none',
    border: '3px solid #284047',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    color: '#284047',
    textAlign: 'center',
  },
}

function ExistingCustomerStep3 ({
  data: { deviceSettings: { devices: devicesList }, lookup, lookupReady },
  params: { customerID, deviceID, deviceType },
  intl: { formatMessage },
  company,
  toGroup,
  fromGroup,
  customerOptions,
  groups,
  previousPage,
  onSubmit,
}) {
  const navigate = useNavigate()

  const [devices, setDevices] = useState([])
  const [invalid, setInvalid] = useState(false)
  const [saved, setSaved] = useState(false)
  const [warningModalIsOpen, setWarningModalIsOpen] = useState(false)
  const [waitingModalIsOpen, setWaitingModalIsOpen] = useState(false)
  const [successModalIsOpen, setSuccessModalIsOpen] = useState(false)
  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false)

  const getNewData = useCallback(() => {
    // Implementation for getting new data
  }, [])

  useEffect(() => {
    if (!lookupReady && deviceID) {
      getNewData()
    }

    const devicesArray = []
    let device

    if (devicesList.length > 0) {
      for (let i = 0; i < devicesList.length; i++) {
        devicesArray.push(lookup[devicesList[i]])
      }
      device = devicesArray[0]
    } else if (deviceID) {
      devicesArray.push(lookup[deviceID])
      device = lookup[deviceID]
    } else if (customerID && deviceType) {
      navigate(`/${customerID}/${deviceType}`)
    } else {
      navigate('/home')
    }

    setDevices(devicesArray)
  }, [lookupReady, deviceID, devicesList, lookup, customerID, deviceType, navigate, getNewData])

  const previousPageHandler = useCallback(() => {
    const currentData = {
      devices,
      fromGroup,
      toGroup,
    }
    previousPage(currentData)
  }, [devices, fromGroup, toGroup, previousPage])

  const openSuccessModal = useCallback(() => {
    setSuccessModalIsOpen(true)
    setWarningModalIsOpen(false)
    setErrorModalIsOpen(false)
    setWaitingModalIsOpen(false)
  }, [])

  const openWarningModal = useCallback(() => {
    setWarningModalIsOpen(true)
    setSuccessModalIsOpen(false)
    setErrorModalIsOpen(false)
    setWaitingModalIsOpen(false)
  }, [])

  const openWaitingModal = useCallback(() => {
    setWarningModalIsOpen(false)
    setSuccessModalIsOpen(false)
    setErrorModalIsOpen(false)
    setWaitingModalIsOpen(true)
  }, [])

  const openErrorModal = useCallback(() => {
    setErrorModalIsOpen(true)
    setSuccessModalIsOpen(false)
    setWarningModalIsOpen(false)
    setWaitingModalIsOpen(false)
  }, [])

  const closeWarningModal = useCallback(() => {
    setWarningModalIsOpen(false)
  }, [])

  const closeWaitingModal = useCallback(() => {
    setWaitingModalIsOpen(false)
  }, [])

  const closeErrorModal = useCallback(() => {
    setErrorModalIsOpen(false)
  }, [])

  const isFinished = useCallback(() => {
    const { id: customerID } = AppStore.getCustomer()
    navigate(`/${customerID}/distributor/transferDevices`)
  }, [navigate])

  const sendData = useCallback(() => {
    const { id: customerID } = AppStore.getCustomer()

    const tempData = devices.map((item) => {
      const temp = {
        id: item.id,
      }
      return temp
    })

    setDevicesAction(
      {
        devices: tempData,
        customer_id: company,
        group_id: toGroup,
        distributor_id: customerID,
      },
      (error) => {
        if (error) {
          setSaved('error')
          openErrorModal()
        } else {
          setSaved(true)
          setTimeout(() => {
            openSuccessModal()
          }, 500)
        }
      }
    )
    openWaitingModal()
  }, [devices, company, toGroup, openErrorModal, openSuccessModal, openWaitingModal])

  let saveButtonStyle = `${styles.saveButton} saveButton `
  const successButtonStyle = `${styles.saveButton} saveButton ${notificationStyles.successButton}`

  if (invalid) {
    saveButtonStyle = `${styles.saveButton} saveButton`
  } else if (saved === true) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonSuccess}`
  } else if (saved === 'error') {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonError}`
  }

  const data = AppStore.getData()

  const searchedGroupsData = AppStore.getSearchedGroups()
  const searchedGroups = searchedGroupsData.groups || []

  const grouptoOptions =
    searchedGroups
      .map(
        (group) => new Object({
          value: group.groupID,
          name: group.name,
        })
      )
      .sort((a, b) => a.name.localeCompare(b.name))
  const tileSetInfo = 'default'

  const groupFromOptions = groups
    .map(
      (group) => new Object({
        value: group.groupID,
        name: group.name,
      })
    )

  const warningModalText = formatMessage({
    id: 'settings.warnings.transfer',
    defaultMessage: 'WARNING: Once transferred, devices can only be transferred again by contacting support@altrac.io',
    description: 'WARNING: Confirm transfer',
  })

  const waitingModalText = formatMessage({
    id: 'settings.warnings.transferring',
    defaultMessage: 'Transferring devices...',
    description: 'Transferring devices',
  })

  const errorModalText = formatMessage({
    id: 'settings.error.transfer',
    defaultMessage: 'Error:',
    description: 'Error',
  })

  const successModalText = formatMessage({
    id: 'settings.success.transfer',
    defaultMessage: 'Transfer Successful',
    description: 'Warning: Confirm transfer',
  })

  const {
    modalHeadWarning,
    modalSaveButton,
    modalSaveButtonWarning,
    transferSaveButton,
    finishedButton,
    transferSave,
    modalCancelButton,
    transferWarningGraphic,
    modalHeadCenter,
  } = notificationStyles

  return (
    <div>
      <div className={styles.userInviteInput}>
        <section className={styles.userInput}>
          <FormattedMessage
            id='customer.transferDevices.fromGroup'
            defaultMessage='TRANSFER FROM GROUP'
            description='Transfer From label'
            tagName='h5'
          />
          <div className={styles.userInputValueEdit}>
            <SelectInput
              options={groupFromOptions}
              field='company'
              value={fromGroup}
              disabled
            />
          </div>
        </section>
        <section className={styles.userInput}>
          <FormattedMessage
            id='customer.transferDevices.toGroup'
            defaultMessage='TRANSFER TO GROUP'
            description='Transfer From label'
            tagName='h5'
          />
          <div className={styles.userInputValueEdit}>
            <SelectInput
              options={grouptoOptions}
              field='company'
              value={toGroup}
              disabled
            />
          </div>
        </section>
        <section className={styles.userInput}>
          <FormattedMessage
            id='customer.transferDevices.toCustomer'
            defaultMessage='TRANSFER TO CUSTOMER'
            description='Transfer From Customer label'
            tagName='h5'
          />
          <div className={styles.userInputValueEdit}>
            <SelectInput
              options={customerOptions}
              field='company'
              value={company}
              disabled
            />
          </div>
        </section>
      </div>

      <div>
        <GridList
          devices={devices}
          sort={data.sort}
          tileInfo={tileSetInfo}
        />
      </div>
      <CapitalButton
        text={formatMessage({
          id: 'existingCustomer.confirm',
          defaultMessage: 'Confirm',
          description: '',
        })}
        buttonFunction={openWarningModal}
        hSize='h2'
        style={saveButtonStyle}
        disabled={invalid}
      />
      <Modal
        isOpen={warningModalIsOpen}
        onRequestClose={closeWarningModal}
        style={customStyles}
        contentLabel='warningModal'
      >
        <div className={`${styles.warningGraphic} ${transferWarningGraphic}`}>
          <WarningTriangle />
        </div>
        <h3 className={`${modalHeadWarning} ${modalHeadCenter}`}>{warningModalText}</h3>
        <h3 className={`${transferSave}`}>
          <button className={`${modalSaveButtonWarning} ${transferSaveButton}`} style={{ textTransform: 'uppercase' }} onClick={sendData}>
            {formatMessage({
              id: 'general.confirmTransfer',
              defaultMessage: `Transfer ${devices.length > 1 ? `${devices.length} devices` : `${devices.length} device`}`,
            })}
          </button>
          <button
            className={`${modalSaveButton} ${modalCancelButton} ${transferSaveButton}`}
            style={{ textTransform: 'uppercase' }}
            onClick={closeWarningModal}
          >
            {formatMessage({
              id: 'general.cancel',
              defaultMessage: 'Cancel',
            })}
          </button>
        </h3>
      </Modal>

      <Modal
        isOpen={waitingModalIsOpen}
        onRequestClose={closeWarningModal}
        style={customStyles}
        contentLabel='waitingModal'
      >
        <div className={`${styles.warningGraphic} ${transferWarningGraphic}`}>
          <WarningTriangle />
        </div>
        <h3 className={`${modalHeadWarning} ${modalHeadCenter}`}>{waitingModalText}</h3>
      </Modal>

      <Modal
        isOpen={errorModalIsOpen}
        onRequestClose={closeErrorModal}
        style={customStyles}
        contentLabel='errorModal'
      >
        <div className={`${styles.warningGraphic} ${transferWarningGraphic}`}>
          <WarningTriangle />
        </div>
        <h3 className={`${modalHeadWarning} ${modalHeadCenter}`}>{errorModalText}</h3>
        <p>
          Please send an email to
          <a href='mailto:support@altrac.io'>support@altrac.io</a>
          {' '}
          for assistance with this error.
        </p>
        <h3 className={`${transferSave}`}>
          <button
            className={`${modalSaveButton} ${modalCancelButton} ${transferSaveButton}`}
            style={{ textTransform: 'uppercase' }}
            onClick={closeErrorModal}
          >
            {formatMessage({
              id: 'general.cancel',
              defaultMessage: 'Cancel',
            })}
          </button>
        </h3>
      </Modal>

      <Modal
        isOpen={successModalIsOpen}
        style={completionStyles}
        contentLabel='successModal'
      >
        <div className={`${styles.warningGraphic} ${transferWarningGraphic}`}>
          <SelectionCheckIcon color='#284047' width='65' height='65' />
        </div>
        <h3 className={`${modalHeadWarning} ${modalHeadCenter}`}>{successModalText}</h3>
        <h3 className={transferSave}>

          <button className={`${modalSaveButtonWarning} ${transferSaveButton} ${finishedButton}`} onClick={isFinished}>
            {formatMessage({
              id: 'existingCustomer.finished',
              defaultMessage: 'Finished',
            })}
          </button>
        </h3>
      </Modal>
    </div>
  )
}

export default injectIntl(ExistingCustomerStep3)
